import React, { useEffect, useState } from 'react'
import { Button, Tooltip, CircularProgress, Box } from '@mui/material'
import { AddNode } from '../../../assets/images'
import { useCountry } from '../../../CustomHooks/useCountry';
import { useStateMaster } from '../../../CustomHooks/useStateMaster';
import { useCity } from '../../../CustomHooks/useCity';
import { onNumberOnlyChange, onSpecialChangeOnly } from '../EntityConfigUtils/entityConfigUtils';
import { updateBulkSiteDetails } from '../../../services/configurationServices';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';

const SiteBulkEditForm = ({ setShowBulkEditModal, selectedCustomer, editCountryId, selectedSiteIds, handleApplyFilters, fetchFilters }) => {

    const [countryError, setCountryError] = useState('');
    const [stateError, setStateError] = useState('');
    const [cityError, setCityError] = useState('');
    const [regionError, setRegionError] = useState('');
    const [pincodeError, setPincodeError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [areaError, setAreaError] = useState('');

    const [stateId, setStateId] = useState('');
    const [cityId, setCityId ] = useState('');

    const { country } = useCountry();
    const { state, getState } = useStateMaster()
    const { city, getCity } = useCity();


    const bulkUpdateSite = () => {
        let isValid = true
        if(!stateId) {
            setStateError('Please select a state');
            isValid = false;
        }
        if(!cityId) {
            setCityError('Please select a city');
            isValid = false;
        }
        if(!isValid) {
            return;
        }

        let user = JSON.parse(localStorage.getItem("user"));
        let selected = selectedSiteIds.map((item) => parseInt(item))
        let obj = {
            "UserId": user.Id,
            "ClientId": selectedCustomer ? selectedCustomer.value : 0,
            "SiteID": selected, // Will come here for selected sites   
            "StateId": stateId,
            "City": cityId,
        }
        console.log("PayloadObj", obj)

        updateBulkSiteDetails(obj)
            .then((res) => {
                console.log("Res", res);
                if(res.Data){
                    console.log("Res", res.Data);
                    if(res.Status == "success"){
                        SuccessToast('Site bulk updated successfully.')
                        handleApplyFilters();
                        fetchFilters();
                        setShowBulkEditModal(false)
                    }
                }
            })
            .catch(err => {
                console.log("Error", err)
            })

    }

    useEffect(() => {
        console.log('editCountryId:', editCountryId);
        getState(editCountryId)
    }, [editCountryId])

    return (
        <>
            <div className='SiteFormAdditionForm border-top-0'>
                <form style={{ width: "100%" }}>
                    <div className="site-form">

                        {/* <div className="inputMainContainer w40dot75rem">
                            <div style={{ display: "flex" }}>
                                <div className="inputTypeLabelContainer" style={{ width: "95%" }}>
                                    <label className='formFieldLabels'>Select Customer</label>
                                    <select
                                        required
                                        className="inputType ArrowSelectClass"
                                    >
                                        <option key="0" disabled={false} value="0">Select Customer*</option>
                                        <option>Customer 1</option>
                                        <option>Customer 1</option>
                                        <option>Customer 1</option>
                                        <option>Customer 1</option>
                                    </select>
                                </div>

                                <Tooltip title=" Add Customer" placement="bottom">
                                    <button className="addCustomer" style={{ marginLeft: "10px" }}>
                                        <span className="ViewUpdate">
                                            <img src={AddNode} alt="add plus icon" />
                                        </span>
                                    </button>
                                </Tooltip>
                            </div>
                            <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Site Name</label>
                                <input
                                    className="inputType"
                                    placeholder="Site Name*"
                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
                            </div>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Country</label>
                                <select className="inputType ArrowSelectClass"
                                    onChange={(e) => {
                                        setCountryError('')
                                    }}
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Country*</option>
                                    {country &&
                                        country.map((val) => (
                                            <option value={val.countryname} key={val.countrymasterid} id={val.countrymasterid}>
                                                {val.countryname}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {countryError} </span></p>
                            </div>
                        </div> */}

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select State*</label>
                                <select className="inputType ArrowSelectClass"
                                    onChange={(e) => {
                                        setStateError('')
                                        getCity(e.target.value);
                                        setStateId(e.target.value);
                                    }}
                                >
                                    <option key="0" disabled={false} value="0">Select State*</option>
                                    {state &&
                                        state.map((val) => (
                                            <option value={val.statemasterid} key={val.statemasterid} id={val.statemasterid}>
                                                {val.statename}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {stateError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>City*</label>
                                {/* <input
                                    className="inputType"
                                    placeholder="City*"
                                /> */}
                                <select
                                    className="inputType ArrowSelectClass"
                                    onChange={(e) => {
                                        setCityError('')
                                        setCityId(e.target.value);
                                    }}
                                >
                                    <option key="0" disabled={false} value="0">Select City*</option>
                                    {city &&
                                        city.map((val) => (
                                            <option value={val.CityName} key={val.CityID}>
                                                {val.CityName}
                                            </option>
                                        ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {cityError} </span></p>
                            </div>
                        </div>

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Region</label>
                                <input
                                    className="inputType"
                                    placeholder="Region*"
                                    onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setRegionError('')
                                    }}
                                    onChange={() => {
                                        setRegionError('')
                                    }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {regionError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Pin Code</label>
                                <input
                                    className="inputType"
                                    placeholder="Pin Code*"
                                    onKeyPress={(e) => {
                                        onNumberOnlyChange(e);
                                        setPincodeError('')
                                    }}

                                    onChange={() => {
                                        setPincodeError('')
                                    }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {pincodeError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Address</label>
                                <input
                                    maxLength={100}
                                    className="inputType"
                                    placeholder="Address*"
                                    onChange={() => {
                                        setAddressError('')
                                    }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {addressError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Area</label>
                                <input
                                    className="inputType"
                                    placeholder="Area*"
                                    onKeyPress={(e) => {
                                        onSpecialChangeOnly(e);
                                        setAreaError('')
                                    }}
                                    onChange={() => {
                                        setAreaError('')
                                    }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {areaError} </span></p>
                            </div>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Branch ID</label>
                                <input
                                    maxLength={50}
                                    className="inputType"
                                    placeholder="Branch ID*"
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                            </div>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Site Type</label>
                                <select className="inputType ArrowSelectClass">
                                    <option key="0" disabled={false} value={0} id="0"> Site Type</option>
                                    <option>General Site</option>
                                    <option>Special Site</option>
                                    <option>Critical Site</option>
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                            </div>
                        </div> */}
                    </div>
                </form>
            </div>
            <div style={{ textAlign: "center" }}>
                <button
                    className="DataAccessEdit mt-3"
                    onClick={bulkUpdateSite}
                    style={{ width: "100px" }}>
                    <span className="ViewUpdate">Submit</span>
                </button>
                <button
                    onClick={() => { setShowBulkEditModal(false) }}
                    className="DataAccessEdit mt-3"
                    style={{ width: "100px" }}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </>
    )
}

export default SiteBulkEditForm